import { Job, Project } from '~/common/entities/Project/ProjectTypes';
import { momentDurationToSeconds } from './timeUtils';

export interface CreateJobValues {
  name: string;
  project: string;
  durationHours: number;
  durationMinutes: number;
  durationSeconds: number;
  description: string;
  step_number: number;
  done_per_project: number;
  departmentId: string;
  important_message: string;
}

export function getTimeOfProject(project: Project | null | undefined) {
  if (!project) {
    return null;
  }
  if (project.jobs && project.jobs.length > 0) {
    return project.jobs
      .map((job) => job.duration as number)
      .map((duration) =>
        typeof duration === 'string'
          ? momentDurationToSeconds(duration)
          : duration,
      )
      .reduce((previous, current) => previous + current, 0);
  }
  return null;
}

const getHighestStepNumberOfJobsOfProject = (project: Project) => {
  let highestStepNumber = 0;
  project?.jobs?.forEach((job) => {
    if (job.step_number > highestStepNumber)
      highestStepNumber = job.step_number;
  });
  return highestStepNumber;
};

const stepNumberOfCreatedJobIsTooHigh = (
  stepNumberOfCreatedJob: number,
  highestStepNumber: number,
) => {
  return stepNumberOfCreatedJob > highestStepNumber + 1;
};

const stepNumbersOfJobsHaveToBeUpdated = (
  stepNumberOfCreatedJob: number,
  highestStepNumber: number,
) => {
  return stepNumberOfCreatedJob <= highestStepNumber;
};

const updateChangedStepNumbers = (
  project: Project,
  stepNumberOfCreatedJob: number,
): Project => {
  project?.jobs?.forEach((job) => {
    if (job.step_number >= stepNumberOfCreatedJob) job.step_number += 1;
  });
  return project;
};

export interface ProjectsAndStepNumberOfCreatedJob {
  projects: Project[];
  stepNumberOfCreatedJob: number;
}

export const getProjectsWithUpdatedStepNumbersInProjectOfCreatedJob = (
  projects: Project[],
  values: CreateJobValues,
): ProjectsAndStepNumberOfCreatedJob => {
  let tmpProject = projects.find((project) => project.id == values.project);
  let stepNumberOfCreatedJob = values.step_number;
  if (tmpProject) {
    const highestStepNumber = getHighestStepNumberOfJobsOfProject(tmpProject);
    if (
      stepNumberOfCreatedJobIsTooHigh(stepNumberOfCreatedJob, highestStepNumber)
    ) {
      stepNumberOfCreatedJob = highestStepNumber + 1;
    }
    if (
      stepNumbersOfJobsHaveToBeUpdated(
        stepNumberOfCreatedJob,
        highestStepNumber,
      )
    ) {
      tmpProject = updateChangedStepNumbers(tmpProject, stepNumberOfCreatedJob);
    }
  }

  const returnValue: ProjectsAndStepNumberOfCreatedJob = {
    projects,
    stepNumberOfCreatedJob,
  };
  return returnValue;
};

export const getProjectsWithUpdatedStepNumbersInProjectsWithDeletedJobAndWithoutDeletedJob =
  (projects: Project[], deletedJob: Job) => {
    const tmpProject = projects.find((project) =>
      project?.jobs?.find((job) => job.id == deletedJob.id),
    );
    const stepNumberOfDeletedJob = deletedJob.step_number;
    if (tmpProject) {
      tmpProject.jobs = tmpProject?.jobs?.filter(
        (job) => job.id != deletedJob.id,
      );
    }
    tmpProject?.jobs?.forEach((job) => {
      if (job.step_number >= stepNumberOfDeletedJob) job.step_number -= 1;
    });
    return projects;
  };
